"use client";

import useTypewriter from "@/hooks/useTypewriter";
import { TypewriterProps } from "@/types/props/ui/Typewriter.type";

function Typewriter(props: TypewriterProps) {
  const typingText = useTypewriter({
    texts: props.texts,
    typingSpeed: props.typingSpeed,
    deletingSpeed: props.deletingSpeed,
    pauseDuration: props.pauseDuration,
    loop: props.loop,
    uppercase: props.uppercase,
  });

  return <p className="text-primary min-h-20 text-3xl leading-snug wrap-break-word">{typingText}</p>;
}

export default Typewriter;
